// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';


export const getTableSettings = (payload = null) => http.post('apiUserGroup/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiUserGroup/getRows', payload).then(getData);

export const create = (row) => http.post('apiUserGroup/create', row).then(getData);

export const update = (row) => http.put('apiUserGroup/edit&ID=' + row.ID, row).then(getData);

export const remove = (row) => http.post('apiUserGroup/delete',row).then(getData);

export const getRow = (rowID) => http.get(`apiUserGroup/getRow&ID=${rowID}`).then(getData);
